import { api } from "../../../config/axios/interceptor";

export async function getAllPatients(
  searchKey,
  pageSize,
  page,
  key,
  order,
  sortByTag,
) {
  try {
    const params = new URLSearchParams();

    // Always add the mandatory searchKey
    if (searchKey) params.append("search", searchKey);

    // Conditionally add optional parameters
    if (pageSize) params.append("pageSize", pageSize);
    if (page) params.append("page", page);
    if (key && order) params.append(key, order); // only append if both key and order exist
    if (sortByTag) params.append("tag", sortByTag);

    // Construct the final URL with the dynamically created params
    const response = await api.get(`patient?${params.toString()}`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getPatienttypes() {
  try {
    const response = await api.get(`/patient/getPatienttypes`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTreatmentsHistory(id) {
  try {
    const response = await api.get(
      `/patient/treatments_history?patient_id=${id}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getSpecializationtypes() {
  try {
    const response = await api.get(`/patient/getSpecializationtypes`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getPatientAddOns() {
  try {
    const response = await api.get(`/patient/getPatientAddOns`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getSinglePatient(id) {
  try {
    const response = await api.get(`patient/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function deletePatient(id) {
  try {
    const response = await api.delete(`patient/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTreatmentsProfile(id) {
  try {
    const response = await api.get(`treatment/patientID?patient_id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllPrescriptionsProfile(id) {
  try {
    const response = await api.get(`prescription/patientID?patient_id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllAppointmentsProfile(id) {
  try {
    const response = await api.get(`appointment/patientID?patient_id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getTreatmentSummaries(id) {
  try {
    const response = await api.get(`summary/patientID?patient_id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function sendMessageTreatmentSummaries(payload) {
  /**
  eg payload: {
    "summaryId": "65af79d2ccfdb93926166c08",
    "whatsapp": "true",
    "message": "true" 
  }
   */
  try {
    const response = await api.post(`summary/message1`, payload);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addNewTagText(payload) {
  try {
    const response = await api.put(`/company/tag`, payload);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function fetchTagTexts(payload) {
  try {
    const response = await api.get(`/company/tag`, payload);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function printTreatmentSummaries(id) {
  try {
    const response = await api.get(`summary_print/print/` + id);
    const fileURL = response?.data?.url;
    if (fileURL) {
      window.open(fileURL, "_blank", "noopener,noreferrer");
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllLabsProfile(id) {
  try {
    const response = await api.get(`lab/patientID?patient_id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updatePatientNotes(id, notes) {
  try {
    const response = await api.put(`patient/${id}/notes`, { notes });
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllinvoiceProfile(id) {
  try {
    const response = await api.get(`invoice/patientID?patient_id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllMedBillProfile(id) {
  try {
    const response = await api.get(`medbill/patientID?patient_id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updatePatientFiles(payload, id) {
  try {
    const response = await api.put(`patient/` + id, payload);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function removePatientPic(id) {
  try {
    const response = await api.delete(`patient/deleteProfilepic/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}
// ---- Bulk upload (patient_database page) ----
// `bulk-template` returns the header-only .xlsx the clinic fills in.
// `bulk-validate` parses + validates uploaded rows; never writes to the DB.
// `bulk-create` accepts the rows the user confirmed in the preview and
// persists via insertMany. Welcome WhatsApp/SMS are intentionally NOT
// triggered for bulk-created patients (see controller).
export async function downloadBulkTemplate() {
  const response = await api.get("patient/bulk-template", {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = "patient_bulk_template.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function bulkValidatePatients(file) {
  const form = new FormData();
  form.append("file", file);
  const response = await api.post("patient/bulk-validate", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response;
}

export async function bulkCreatePatients(rows) {
  const response = await api.post("patient/bulk-create", { rows });
  return response;
}

export async function getProfilePic(id) {
  try {
    const response = await api.get(`patient/getProfilePic/` + id, {
      responseType: "blob",
    });
    const blob = response?.data;

    // Check if blob has data
    if (blob.size > 0) {
      const imageUrl = URL.createObjectURL(blob);
      return imageUrl;
    } else {
      // Return default image URL if blob has no data
      return "/default_pro_pic.png";
    }
  } catch (error) {
    // Handle the error or return a default image URL
    return "/default_pro_pic.png";
  }
}
